/** Placeholder for a §16.2 console whose feature agent has not registered routes yet; keeps navigation honest. */
import { Button } from '@windrop/ui';
import { EmptyState } from '../components/EmptyState';
import { PageHeader } from '../components/PageHeader';

export function ComingSoonPage({
  title,
  capabilities,
  owner,
}: {
  title: string;
  capabilities: string;
  owner: string;
}) {
  return (
    <>
      <PageHeader title={title} description={capabilities} />
      <EmptyState
        title={`${title} is not wired in this build`}
        body={`The ${owner} module registers this console through src/routes/index.tsx. Nothing here is hidden from you by permission; it simply has not shipped.`}
        action={<Button href="/">Back to dashboard</Button>}
      />
    </>
  );
}
